<div class="modal-header">
    <h4 class="modal-title">
        <i data-feather="plus"></i> Yeni Ürün Ekle
    </h4>
</div>
<div class="modal-body" *blockUI="'section-blocks'">
    <form [formGroup]="productForm" (ngSubmit)="onSubmit()" class="mt-2">
        <div class="row">
            <div class="col-12">
                <div class="form-group mb-2">
                    <label for="title">Ürün Adı</label>
                    <input type="text" formControlName="title" class="form-control" placeholder="Ürün adı" />
                </div>
            </div>

            <div class="col-md-6 col-12">
                <div class="form-group mb-2">
                    <label for="title">Tip</label>
                    <ng-select [items]="unitTypes" formControlName="unitTypeId" placeholder="Tip" bindValue="id"
                        bindLabel="unitTypeName"></ng-select>
                </div>
            </div>

            <div class="col-md-6 col-12">
                <div class="form-group mb-2">
                    <label for="title">Ürün Tipi</label>
                    <select class="form-control" formControlName="productType">
                        <option value="true">Ürün</option>
                        <option value="false">Hizmet</option>
                    </select>
                </div>
            </div>

            <div class="col-md-6 col-12">
                <div class="form-group mb-2">
                    <label for="type">Satış Vergi</label>
                    <ng-select [items]="taxes" formControlName="saleTaxId" placeholder="Satış vergisi" bindValue="id"
                        bindLabel="taxRate"></ng-select>
                </div>
            </div>

            <div class="col-md-6 col-12">
                <div class="form-group mb-2">
                    <label for="title">Satış Fiyat</label>
                    <input type="number" formControlName="salePrice" class="form-control" placeholder="Satış fiyatı" />
                </div>
            </div>

            <div class="col-md-6 col-12">
                <div class="form-group mb-2">
                    <label for="type">Alış Vergi</label>
                    <ng-select [items]="taxes" formControlName="purchaseSaleTaxId" placeholder="Alış vergisi"
                        bindValue="id" bindLabel="taxRate"></ng-select>
                </div>
            </div>

            <div class="col-md-6 col-12">
                <div class="form-group mb-2">
                    <label for="title">Alış Fiyat</label>
                    <input type="number" formControlName="purchasePrice" class="form-control"
                        placeholder="Alış fiyatı" />
                </div>
            </div>

            <div class="col-md-6 col-12">
                <div class="form-group mb-2">
                    <label for="type">Kategori</label>
                    <ng-select [items]="categories" formControlName="categoryId" placeholder="Kategory Seç"
                        bindValue="id" bindLabel="categoryName"></ng-select>
                </div>
            </div>

            <div class="col-md-6 col-12">
                <div class="form-group mb-2">
                    <label for="type">Para Birimi</label>
                    <ng-select [items]="currencies" formControlName="currencyId" placeholder="Para birimi seç"
                        bindValue="id" bindLabel="currencyName"></ng-select>
                </div>
            </div>

            <div class="col-md-6 col-12">
                <div class="form-group mb-2">
                    <label for="type">Model</label>
                    <ng-select [items]="brands" bindLabel="name" bindValue="id" groupBy="brandName" formControlName="brandModalId">
                        <ng-template ng-optgroup-tmp let-item="item">
                            {{ item.brandName || 'Unnamed group' }}
                        </ng-template>
                    </ng-select>
                </div>
            </div>
        </div>
        <div class="ml-1 d-flex justify-content-end">
            <button type="submit" class="btn btn-success mr-1" rippleEffect
                [disabled]="productForm.invalid">Kaydet</button>
            <button type="reset" class="btn btn-outline-secondary" rippleEffect (click)="closeModal()">İptal</button>
        </div>
    </form>
</div>